export { MaxWidth } from './MaxWidth';
export type { MaxWidthProps } from './MaxWidth';
export type { MaxWidthVariants } from './MaxWidth.css';